const topbar = {
    docs: 'Dokumente',
    help: 'Hilfe',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
